App.controller('HealthVariantCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$stateParams', '$mdDialog', 'Config', function ($scope, $sce, $state, $http, packageService, $stateParams, $mdDialog, Config) {
    $scope.stateParams = $stateParams;

    $scope.page = 'health_variant';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Warianty opieki medycznej';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.dashboard';
    $scope.$emit('link', $scope.link);

    if ($scope.stateParams.choose && $scope.stateParams.prices) {
        $scope.choose = $scope.stateParams.choose;
        $scope.prices = $scope.stateParams.prices;
        $scope.summary = $scope.stateParams.summary;
    } else {
        $scope.choose = [];
        $scope.prices = [];
        $scope.summary = 0;
    }


    $scope.persons = [{
        "type": "USER",
        "name": "Ubezpieczony pracownik"
    },
        {
            "type": "PARTNER",
            "name": "Współmałżonek lub partner"
        },
        {
            "type": "CHILD",
            "name": "Pełnoletnie dziecko"
        }
    ];

    $scope.fields = [{
        "name": "Śmierć ubezpieczonego"
    },
        {
            "name": "Śmierć w następstwie NW"
        },
        {
            "name": "Zgon ubezpieczonego spowodowany długim zdaniem, które nie mieści się w jenej linijce"
        }
    ];

    // style="width: {{0.75 * }}"
    $scope.allLength = 0;
    $scope.groupwidth = [];
    $scope.singleLength = [];
    packageService.dataLifeList().then(function (data) {
        $scope.lifePackages = data.data.group;

        for (var a = 0; a < $scope.lifePackages.length; a++) {
            $scope.singleLength[a] = 0;
            for (var b = 0; b < $scope.lifePackages[a]['item'].length; b++) {
                $scope.allLength++;
                $scope.singleLength[a]++;
            }
        }

        for (var a = 0; a < $scope.lifePackages.length; a++) {
            $scope.groupwidth[a] = $scope.singleLength[a] / $scope.allLength * 75 + '%';
        }


        if (!$scope.stateParams.prices) {
            for (var a = 0; a < $scope.persons.length; a++) {
                $scope.prices[a] = [];
                // $scope.choose[a] = [];

                for (var b = 0; b < $scope.lifePackages.length; b++) {
                    $scope.prices[a][b] = 0;
                    // $scope.choose[a][b] = null;
                }
            }
        }
    });

    $scope.addChild = function () {
        $scope.persons.push({
            "type": "CHILD",
            "name": "Pełnoletnie dziecko"
        });

        $scope.prices[$scope.persons.length - 1] = [];

        for (var b = 0; b < $scope.lifePackages.length; b++) {
            $scope.prices[$scope.persons.length - 1][b] = 0;
        }
    };

    $scope.deleteChild = function (obj) {
        $scope.persons.splice(obj, 1);
        $scope.prices.splice(obj, 1);

        $scope.summary = 0;
        for (var a = 0; a < $scope.prices.length; a++) {
            for (var b = 0; b < $scope.prices[a].length; b++) {
                $scope.summary += $scope.prices[a][b];
            }
        }
    };

    $scope.checkPrice = function (person, group, price) {
        $scope.prices[person][group] = price;

        $scope.summary = 0;
        for (var a = 0; a < $scope.prices.length; a++) {
            for (var b = 0; b < $scope.prices[a].length; b++) {
                $scope.summary += $scope.prices[a][b];
            }
        }
    }

    $scope.uncheck = function (keyPerson, keyGroup) {
        if ($scope.choose[keyPerson][keyGroup]) {
            $scope.choose[keyPerson][keyGroup] = null;
        }
    }

    $scope.next = function () {
        // for (var a = 0; a < $scope.persons.length; a++) {

        //     for (var b = 0; b < $scope.lifePackages.length; b++) {
        //         console.log($scope.choose[a]);
        //         if (!$scope.choose[a]) {
        //             return 0;
        //         }
        //     }
        // }

        if (!$scope.choose[0]) {
            $scope.showPopUp('', 'Dokonaj wyboru przy wariantach', 'Aby przejść dalej zaznacz minimum jeden wariant dla pracownika.');
            return 0;
        }

        $state.go('root.life.salaried', {
            persons: $scope.persons,
            choose: $scope.choose,
            prices: $scope.prices,
            summary: $scope.summary
        });
    };

    $scope.fillDeclaration = function() {
        var dateNow = moment().toDate();
        var dateTo = moment('2019-10-21').toDate();
        dateTo.setHours(0, 0, 0, 0);

        if (dateTo.getTime() <= dateNow.getTime()) {
            $scope.showPopUp(
                '',
                '',
                'Możliwość przystąpień do programu abonamentów zdrowotnych w POLMED została wyłączona. Od 1 grudnia 2019 r. rusza nowy program ubezpieczenia zdrowotnego w TU ZDROWIE. Aby wypełnić deklarację przystąpienia, należy przejść do zakładki "Opieka medyczna".',
                'Przejdź do nowego programu',
                'root.healthInsuranceInfo.start',
                'Rozumiem',
                '');
            return;
        }

        var url = $scope.__logged ? 'root.home.insurance.list' : 'root.login';
        $state.go(url);
    };

    function initInformationPopUp() {
        var dateNow = moment().toDate();
        var dateTo = moment('2019-10-20').toDate();
        dateTo.setHours(23, 59, 59, 999);

        if (dateNow.getTime() <= dateTo.getTime()) {
            $scope.showPopUp(
                '',
                '',
                'Od 1 grudnia 2019 r. obowiązywać będzie nowy program ubezpieczenia zdrowotnego dla pracowników i członków ich rodzin. Aby przystąpić do nowego programu należy przejść do zakładki "Opieka medyczna".',
                'Przejdź do nowego programu',
                'root.healthInsuranceInfo.start',
                'Rozumiem',
                '');
            return;
        }

        dateTo = moment('2019-10-21').toDate();
        dateTo.setHours(0, 0, 0, 0);

        if (dateTo.getTime() <= dateNow.getTime()) {
            $scope.showPopUp(
                '',
                '',
                'Możliwość przystąpień do programu abonamentów zdrowotnych w POLMED została wyłączona. Od 1 grudnia 2019 r. rusza nowy program ubezpieczenia zdrowotnego w TU ZDROWIE. Aby wypełnić deklarację przystąpienia, należy przejść do zakładki "Opieka medyczna".',
                'Przejdź do nowego programu',
                'root.healthInsuranceInfo.start',
                'Rozumiem',
                '');
        }
    }

    $scope.showPopUp = function (ev, head, content, text, target, secondButtonText, secondButtonTarget) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                },
                secondButton: {
                    text: secondButtonText,
                    target: secondButtonTarget
                }
            }
        }).then(function (data) {

        }, function () {

        });
    };

    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.confirm = function () {
            $mdDialog.hide($scope.locals);
        };
    }

    initInformationPopUp();

}]);
